
    import './styles.scoped.css';
    export default {
  "radio-button": "awsui_radio-button_zdbjz_sil6x_42"
};
  